"use strict";
import {http} from '../../core';
// import Config from "../../app.config";
// const RequestService = http.create({ baseURL: Config.BASE_API });
const RequestService = http.create();

export default {
    // 获取列表数据(分页)
    getList:function (params) {
        return RequestService.get("category/type/list",params);
    },
    // 添加数据
    addMes:function (params) {
        return RequestService.post("category/add",params);
    },
    // 修改数据
    changeMes:function (params) {
        return RequestService.post("category/update",params);
    },
    // 删除数据
    delMes:function (params) {
        return RequestService.get("category/del",params);
    },
    // 根据父分类id,获取所有子分类(分页)
    getChildMes:function (params) {
        return RequestService.get("category/children/list",params);
    },
    //获取分类列表
    getSortListMes:function (params) {
        return RequestService.get("category/type/list/all",params);
    },
    //根据父分类id,获取所有子类列表(不分页)
    getChildSortListMes:function (params) {
        return RequestService.get("category/children/list/all",params);
    },
    //根据id获取详情
    getDetailMes:function (params) {
        return RequestService.get("category/detail",params);
    },
    //根据type获取配置项分类的图标
    getConfigIcon(params){
        return RequestService.get('icon/type/list',params)
    }
}
